__turbopack_context__.v({
  "todo-alert": "TodoCard-module-scss-module__-tj8GW__todo-alert",
  "todo-alert-WARNING": "TodoCard-module-scss-module__-tj8GW__todo-alert-WARNING",
  "todo-alert-amount": "TodoCard-module-scss-module__-tj8GW__todo-alert-amount",
  "todo-alert-chevron": "TodoCard-module-scss-module__-tj8GW__todo-alert-chevron",
  "todo-alert-circle": "TodoCard-module-scss-module__-tj8GW__todo-alert-circle",
  "todo-alert-wrapper": "TodoCard-module-scss-module__-tj8GW__todo-alert-wrapper",
});
